import React from "react";
import { Link } from "react-router-dom";

export const ProductCard = ({ product, priceFrom, image, title, subtitle, to, badge, testId }) => (
  <Link to={to || `/product/${product.id}`} data-testid={testId || `product-card-${product.id}`}
    className="gv-lift group block bg-[#141518] border border-white/10 hover:border-[var(--gv-blue)] transition-colors overflow-hidden">
    <div className="aspect-square overflow-hidden bg-black relative">
      <img src={image || product.front_image} alt={title || product.name} loading="lazy"
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      {(badge || product.popular) && <span className="absolute top-3 left-3 bg-[var(--gv-blue)] text-black text-[10px] uppercase tracking-widest font-bold px-2 py-1">{badge || "Popular"}</span>}
    </div>
    <div className="p-4">
      <h3 className="font-bold text-sm sm:text-base leading-tight">{title || product.name}</h3>
      <p className="text-xs text-gray-400 mt-1">{subtitle || (/hoodie/i.test(product?.name || "") ? "Heavy Blend Hoodie" : "Performance Tee")}</p>
      <p className="mt-2 text-[var(--gv-blue-bright)] font-bold">From ${priceFrom}</p>
    </div>
  </Link>
);
